/**
 * apiClient.js — shared axios instance for components that use axios instead of
 * fetch() (apiConfig.js's window.fetch patch only covers fetch() call sites, so
 * axios needs its own auth wiring). Mirrors the same behavior: attach
 * Authorization: Bearer <session_token> to every request, and on a 401 clear the
 * stale session and bounce to login — same contract as apiConfig.js's fetch patch,
 * just for axios.
 */
import axios from "axios";
import API_BASE from "./apiConfig";

const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  try {
    const raw = localStorage.getItem("sixers_user");
    const token = raw ? JSON.parse(raw)?.session_token : null;
    if (token) {
      config.headers = { ...(config.headers || {}), Authorization: `Bearer ${token}` };
    }
  } catch { /* malformed storage — proceed without a token */ }
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err?.response?.status === 401) {
      try { localStorage.removeItem("sixers_user"); } catch { /* ignore */ }
      if (!window.location.pathname.startsWith("/register")) {
        window.location.reload();
      }
    }
    return Promise.reject(err);
  }
);

export default api;
